import { DisplayValuesMap } from '~/common/types/data';
import { FullPerson } from '~/common/types/people';

export type PersonField = Exclude<
  keyof FullPerson,
  | 'personId'
  | 'propertyId'
  | 'householdId'
  | 'householdPersonId'
  | 'tenancyId'
  | 'isTenant'
  | 'isMainTenant'
  | 'isHistoric'
>;

export const personFieldDisplayValues: DisplayValuesMap<PersonField> = {
  fullName: 'Name',
  title: 'Title',
  forename: 'Forename',
  initials: 'Initials',
  surname: 'Surname',
  otherName: 'Other name',
  dateOfBirth: 'Date of birth',
  relationToTenant: 'Relationship to tenant',
  genderAtBirth: 'Gender same as sex registered at birth',
  gender: 'Gender',
  maritalStatus: 'Marital status',
  economicStatus: 'Economic status',
  ethnicOrigin: 'Ethnicity',
  language: 'Preferred language',
  sexuality: 'Sexuality',
  religion: 'Religion',
  preferredMethodOfContact: 'Preferred method of contact',
  supportNeeds: 'Support needs',
  reasonableAdjustments: 'Reasonable adjustments',
  communicationAdjustments: 'Communication adjustments',
  communicationPreferences: 'Communication preferences',
  pcfraStatus: 'PCFRA status',
  pcfraStatusComments: 'PCFRA status comments',
  pcfraReviewDate: 'PCFRA review date',
  rpeepStatus: 'RPEEP status',
  emailAddresses: 'Email addresses',
  mobileNumbers: 'Mobile numbers',
  smsOnlyNumbers: 'SMS only numbers',
  otherPhoneNumbers: 'Other phone numbers',
  householdMemberEnded: 'Household member ended',
};
